import { render, staticRenderFns } from "./customerInvoiceCreateCreditNote.vue?vue&type=template&id=64712b08&scoped=true"
import script from "./customerInvoiceCreateCreditNote.vue?vue&type=script&lang=js"
export * from "./customerInvoiceCreateCreditNote.vue?vue&type=script&lang=js"
import style0 from "./customerInvoiceCreateCreditNote.vue?vue&type=style&index=0&id=64712b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64712b08",
  null
  
)

export default component.exports